import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 1 }

import { reactive, computed, ref, onMounted } from 'vue'
import { LbuSalesWorkReportParams } from '@/api/yuntuSales/salesWorkReport'
import { getDeptInfo } from '@/api/common'

import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import CosStaticSelect from '@/components/CosStaticSelect'
import dayjs from 'dayjs'
import { salesCoachingReport } from '@/api/yuntuSales/analysis'
import { cloneDeep } from 'lodash-es'

const __default__ = { name: 'DcCosLbuSalesCoachingReport' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const deptInfo4List = ref([])

const tableRef = ref()
const searchFrom = reactive<any>({
  queryType: 1,
  startTime: dayjs().startOf('month').format('YYYY/MM/DD 00:00:00'),
  endTime: dayjs().endOf('month').format('YYYY/MM/DD 23:59:59')
})
const searchSuccessParams = ref<any>({})
const routeFilterParams = (status: number|undefined, employeeNo: string|undefined) => {
  const params:any = {}
  params.mentorList = employeeNo ? [employeeNo] : undefined
  params.tutoringStartTime = searchSuccessParams.value.startTime || undefined
  params.tutoringEndTime = searchSuccessParams.value.endTime || undefined
  params.status = status
  return params
}
const fetch = (searchFrom: LbuSalesWorkReportParams, callBack: (res: any) => void) => {
  // const params = customerListFormat(searchFrom) // 处理客户名称和客户编码的批量查询参数
  salesCoachingReport(searchFrom).then((res) => {
    searchSuccessParams.value = cloneDeep(searchFrom)
    callBack(res)
  })
}

const search = () => {
  tableRef.value.search()
}

const fetchDeptInfo = async () => {
  const res = await getDeptInfo({ appId: 'cos_lbu', rootId: '3853844' })
  deptInfo4List.value = res.data?.deptInfo[0]?.children
  deptInfo4List.value.forEach((item: any) => {
    if (item.children && item.children.length) {
      item.children.forEach((o: any) => {
        if (o.children) delete o.children
      })
    }
  })
}

onMounted(() => {
  fetchDeptInfo()
})

const dimensionEnum = [
  { value: 1, label: '区域' },
  { value: 2, label: '组', color: '#EF8D3C', desc: '' },
  { value: 3, label: '销售员', color: '#3FAC46', desc: '' }
]

const customSorter = (dataIndex: string) => {
  return (a: any, b: any, sortOrder?: 'ascend' | 'descend') => {
    if (a.deptLevel4Name === '合计') return sortOrder === 'ascend' ? 1 : -1

    return a[dataIndex] > b[dataIndex] ? 1 : -1
  }
}


const columns = computed(() => {
  const columns = [
    {
      title: '',
      width: 450,
      children: [
        { title: '区域', fixed: 'left', dataIndex: 'deptLevel4Name', width: 100 },
        { title: '组', fixed: 'left', dataIndex: 'deptLevel5Name', width: 100 },
        { title: '销售员', fixed: 'left', dataIndex: 'employeeName', width: 100 }
      ]
    },
    {
      title: '总计(已提交+已确认)',
      width: 270,
      children: [
        { title: '小计', fixed: 'left', dataIndex: 'salesCoachingTotal1', width: 70, sorter: customSorter('salesCoachingTotal1') },
        { title: '销售业绩辅导', fixed: 'left', dataIndex: 'salesCoachingTotal2', route: 'salesCoaching', width: 100, sorter: customSorter('salesCoachingTotal2') },
        { title: '销售技能辅导', fixed: 'left', dataIndex: 'salesCoachingTotal3', route: 'salesSkillsCoaching', width: 100, sorter: customSorter('salesCoachingTotal3') }
      ]
    },
    {
      title: '已提交',
      width: 270,
      children: [
        { title: '小计', dataIndex: 'salesCoachingTotal4', width: 70, sorter: customSorter('salesCoachingTotal4') },
        { title: '销售业绩辅导', dataIndex: 'salesCoachingTotal5', route: 'salesCoaching', status: 1, width: 100, sorter: customSorter('salesCoachingTotal5') },
        { title: '销售技能辅导', dataIndex: 'salesCoachingTotal6', route: 'salesSkillsCoaching', status: 1, width: 100, sorter: customSorter('salesCoachingTotal6') }
      ]
    },
    {
      title: '已确认',
      width: 270,
      children: [
        { title: '小计', dataIndex: 'salesCoachingTotal7', width: 70, sorter: customSorter('salesCoachingTotal7') },
        { title: '销售业绩辅导', dataIndex: 'salesCoachingTotal8', route: 'salesCoaching', status: 2, width: 100, sorter: customSorter('salesCoachingTotal8') },
        { title: '销售技能辅导', dataIndex: 'salesCoachingTotal9', route: 'salesSkillsCoaching', status: 2, width: 100, sorter: customSorter('salesCoachingTotal9') }
      ]
    }
  ]
  if (searchFrom.queryType && searchFrom.queryType < 3) {
    columns[0].children.splice(2, 1)
    columns[0].width = columns[0].width - 100
  }

  if (searchFrom.queryType && searchFrom.queryType < 2) {
    columns[0].children.splice(1, 1)
    columns[0].width = columns[0].width - 100
  }

  return columns
})

const exportRows = () => {
  const et = XLSX.utils.table_to_book(document.querySelector('#lbuSalesCoachingReport'))
  const etout = XLSX.write(et, {
    bookType: 'xlsx',
    bookSST: true,
    type: 'array'
  })
  try {
    FileSaver.saveAs(
      new Blob([etout], {
        type: 'application/octet-stream'
      }),
      `销售辅导情况${dayjs().format('YYYYMMDDHHmmss')}.xlsx`
    )
  } catch (e) {
    console.log(e, etout)
  }
  return etout
}

return (_ctx: any,_cache: any) => {
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_CosCascader = _resolveComponent("CosCascader")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            bordered: "",
            dynamicColumnSetting: false,
            needPage: false,
            columns: columns.value,
            search: searchFrom,
            "onUpdate:search": _cache[6] || (_cache[6] = ($event: any) => ((searchFrom) = $event)),
            onFetch: fetch,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "lbuSalesCoachingReport",
            id: "lbuSalesCoachingReport"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: searchFrom }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, { label: "维度" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_group, {
                        value: searchFrom.queryType,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchFrom.queryType) = $event)),
                        optionType: "button",
                        options: dimensionEnum,
                        onChange: search
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "辅导时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: searchFrom.startTime,
                        "onUpdate:startTime": _cache[1] || (_cache[1] = ($event: any) => ((searchFrom.startTime) = $event)),
                        endTime: searchFrom.endTime,
                        "onUpdate:endTime": _cache[2] || (_cache[2] = ($event: any) => ((searchFrom.endTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "辅导人区域" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CosStaticSelect), {
                        fieldNames: { label: 'label', value: 'id' },
                        options: deptInfo4List.value,
                        mode: "multiple",
                        value: searchFrom.deptLevel4List,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchFrom.deptLevel4List) = $event))
                      }, null, 8, ["options", "value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "辅导人组" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosCascader, {
                        placeholder: "请选择",
                        type: "search",
                        options: deptInfo4List.value,
                        fieldNames: { label: 'label', value: 'id', children: 'children' },
                        appId: "cos_lbu",
                        multiple: "",
                        ids: searchFrom.deptLevel5List,
                        "onUpdate:ids": _cache[4] || (_cache[4] = ($event: any) => ((searchFrom.deptLevel5List) = $event))
                      }, null, 8, ["options", "ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "辅导人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        permission: "",
                        value: searchFrom.employeeNoList,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((searchFrom.employeeNoList) = $event)),
                        mode: "multiple",
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, { onClick: exportRows }, {
                default: _withCtx(() => [
                  _createTextVNode(" 导出 ")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_sales_coaching_report_export_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, text, record}) => [
              (column.route === 'salesCoaching')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (searchFrom.queryType===3)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "ant-table-cell-ellipsis",
                          to: { path: '/lbu/saleCoaching', query: { queryParams: JSON.stringify(routeFilterParams(
                  column.status ? column.status : undefined,
                  record.employeeNo)) } },
                          title: text
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(text === undefined || text === null ?'--':text), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "title"]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(text === undefined || text === null ?'--':text), 1))
                  ], 64))
                : _createCommentVNode("", true),
              (column.route === 'salesSkillsCoaching')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (searchFrom.queryType===3)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "ant-table-cell-ellipsis",
                          to: { path: '/lbu/salesSkillsCoaching', query: { queryParams: JSON.stringify(routeFilterParams(
                column.status ? column.status : undefined,
                record.employeeNo)) } },
                          title: text
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(text === undefined || text === null ?'--':text), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "title"]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(text === undefined || text === null ?'--':text), 1))
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})